import React from 'react'

import {
  AlignItems,
  Box,
  Button,
  ButtonColorVariant,
  Color,
  Display,
  FontWeight,
  Text,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'

const EditButton = withCitrusTheme(Button, (theme) => ({
  '&&': {
    fontSize: theme.tokens.fontSizes[2].fontSize,
    lineHeight: theme.tokens.fontSizes[2].lineHeight,
    padding: `${theme.spacing(1)}px 0 ${theme.spacing(1)}px ${theme.spacing(2)}px`,
  },

  '&&:not(:disabled):focus:not(:focus-visible)': {
    backgroundColor: theme.color(Color.Transparent),
    borderColor: theme.color(Color.Transparent),
    borderWidth: 0,
    boxShadow: 'none',
    color: theme.color(Color.Secondary_400),
    outline: 'none',
  },

  '&&:not(:disabled):active:not(:focus-visible)': {
    backgroundColor: theme.color(Color.Transparent),
    borderColor: theme.color(Color.Transparent),
    borderWidth: 0,
    boxShadow: 'none',
    color: theme.color(Color.Secondary_500),
    outline: 'none',
  },

  '&&:not(:disabled):hover:not(:focus-visible)': {
    backgroundColor: theme.color(Color.Transparent),
    borderColor: theme.color(Color.Transparent),
    borderWidth: 0,
    boxShadow: 'none',
    color: theme.color(Color.Secondary_500),
    outline: 'none',
  },
}))

type FlexPortionSummaryProps = {
  recipeCount: number
  portionCount: number
  onEdit: () => void
  stopEventPropagation?: boolean
  countDataNoCode?: string
  editDataNoCode?: string
}

export const FlexPortionSummary = ({
  recipeCount,
  portionCount,
  onEdit,
  stopEventPropagation = false,
  countDataNoCode,
  editDataNoCode,
}: FlexPortionSummaryProps) => {
  const stopEvent = (event: React.SyntheticEvent) => {
    if (stopEventPropagation) {
      event.stopPropagation()
    }
  }

  return (
    <Box alignItems={AlignItems.Center} display={Display.Flex} gap={2} minWidth="0">
      <Box
        alignItems={AlignItems.Center}
        display={Display.Flex}
        gap={2}
        minWidth="0"
        wrap
        style={{ rowGap: 0 }}
      >
        <Text
          size={2}
          fontWeight={FontWeight.Bold}
          color={Color.ColdGrey_800}
          data-no-code={countDataNoCode}
          style={{ flexShrink: 1, minWidth: 0 }}
        >
          {`${recipeCount} ${recipeCount === 1 ? 'recipe' : 'recipes'}`}
        </Text>
        <Text
          size={2}
          fontWeight={FontWeight.Bold}
          color={Color.ColdGrey_800}
          style={{ flexShrink: 0 }}
        >
          •
        </Text>
        <Text
          size={2}
          fontWeight={FontWeight.Bold}
          color={Color.ColdGrey_800}
          style={{ flexShrink: 1, minWidth: 0 }}
        >
          {`${portionCount} ${portionCount === 1 ? 'portion' : 'portions'}`}
        </Text>
      </Box>
      <EditButton
        aria-label="Edit number of portions"
        colorVariant={ButtonColorVariant.Tertiary}
        data-no-code={editDataNoCode}
        onKeyDown={stopEvent}
        onKeyPress={stopEvent}
        onKeyUp={stopEvent}
        onMouseDown={(event: React.MouseEvent) => {
          if (stopEventPropagation) {
            event.preventDefault()
          }
        }}
        onClick={(event: React.MouseEvent) => {
          stopEvent(event)
          onEdit()
        }}
      >
        Edit
      </EditButton>
    </Box>
  )
}
